// extracted by mini-css-extract-plugin
export default {"scrollbarHidden":"PracticePage_scrollbarHidden__9ir40"};